<template>
	<MStateBox :loading="isLoading" :empty="isEmpty">
		<GridBox2>
			<FileInfoCard
				v-for="(item, index) in currentData"
				:key="index"
				:item="item"
				:formatter="formatter"
				@click="handleClick(item)"
			/>
		</GridBox2>
		<el-pagination
			@size-change="changePageSize"
			@current-change="changeCurrentPage"
			:current-page="currentPage"
			:page-sizes="pageSizes"
			:page-size="pageSize"
			:layout="pageLayout"
			:total="pageTotal"
			background
			hide-on-single-page
		></el-pagination>
	</MStateBox>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import GridBox2 from '@rebuild/materials/shared/common/GridBox2.vue';
import FileInfoCard from '@rebuild/materials/shared/common/FileInfoCard.vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { usePaginationPC } from '@rebuild/hooks/load-more/usePaginationPC';

const props = defineProps({
	languageType: {
		type: Number
	}
});

const { research } = useModuleData();
const { viewModule } = useModuleNavigation();

const formatter = item => ({
	time: item.ptime,
	fileUrl: item.url
});

const processData = response => ({
	data: response.data?.rows || [],
	total: Number(response.data?.total || 0)
});

const currentData = computed(() => {
	const processed = processData(research);
	return processed.data;
});

const isLoading = computed(() => research.loading);
const isEmpty = computed(() => research.empty || !currentData.value.length);

// 分页功能
const handlePaginationChange = () => {
	loadData();
};
const {
	currentPage,
	pageSize,
	pageSizes,
	pageLayout,
	pageTotal,
	changePageSize,
	changeCurrentPage,
	changePageTotal,
	refreshPagination
} = usePaginationPC({
	bindChange: handlePaginationChange
});

const loadData = async () => {
    const params = {
        pagestart: currentPage.value - 1,
        pagenum: pageSize.value,
        title: currentSearchValue.value
    }
    if (typeof props.languageType === 'number') {
        params.languageType = props.languageType;
    }

	await research.refresh(params);

	const processed = processData(research);
	changePageTotal(processed.total);
};

const currentSearchValue = ref('');
const search = searchValue => {
	currentSearchValue.value = searchValue;
	refreshPagination();
};

const handleClick = item => {
	return viewModule('research', item);
};

onMounted(() => {
	loadData();
});

defineExpose({
	search
});
</script>

<style lang="less" scoped></style>